'use client';

import React, { forwardRef } from 'react';
import { FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { type BasicShopUIPropTypes, type BuyerLayoutProps } from 'shop-ui/types';
import { NavigationProvider, useNavigation } from './useNavigation';
import { MenuContent } from './MenuContent';
import './Menu.scss';

interface MenuProps extends BasicShopUIPropTypes, BuyerLayoutProps {
    // 自行加入其他 props
    content: string;
}

export const Menu = forwardRef<HTMLDivElement, MenuProps>((props, ref) => {
    const { styleMap, isBuyer, isEditingMode } = props;

    const menuId = styleMap?.[FEATURE_FLAG_KEYS.SELECTED_MENU] || '';

    const api = useNavigation({
        isBuyer,
        id: menuId,
        openInNewTab: !!styleMap?.[FEATURE_FLAG_KEYS.SHOULD_OPEN_NEW_WINDOW],
        isResponsiveType:
            !!styleMap?.[FEATURE_FLAG_KEYS.RESPONSIVE_MENU_ENABLED] && !isEditingMode,
        menuRef: ref as React.RefObject<HTMLDivElement>,
        isEditingMode,
    });

    return (
        <NavigationProvider value={api}>
            <MenuContent ref={ref} {...props} />
        </NavigationProvider>
    );
});

Menu.displayName = 'Menu';
